import createLucideIcon from '../createLucideIcon';

const ArrowDownRight = createLucideIcon('ArrowDownRight', [
  ['line', { x1: '7', x2: '17', y1: '7', y2: '17', key: 'z8tosr' }],
  ['polyline', { points: '17 7 17 17 7 17', key: '1gmiis' }],
]);

export default ArrowDownRight;
